import gql from 'graphql-tag'

const tag = (what, name) => gql`${require('./' + what + '/' + name + '.graphql')}`

export const getQuery = name => tag('queries', name)
export const getMutation = name => tag('mutations', name)

export const isLogged = error => {
    let isLogged = true
    error.graphQLErrors.forEach(e => {
        if (e.message === `not_logged`) isLogged = false
    })
    return isLogged
}
